// extracted by mini-css-extract-plugin
module.exports = {"root":"Image_root__vazPv","image":"Image_image__2w7KX"};